export const MADE_FOR_YOU_REFRESH = 'MADE_FOR_YOU_REFRESH';
export const MADE_FOR_YOU_LOADING = 'MADE_FOR_YOU_LOADING';
export const MADE_FOR_YOU_LOADING_ERROR = 'MADE_FOR_YOU_LOADING_ERROR';
export const MADE_FOR_YOU_LOADING_SUCCESS = 'MADE_FOR_YOU_LOADING_SUCCESS';
export const MADE_FOR_YOU_CLEAR_BETCARDS = 'MADE_FOR_YOU_CLEAR_BETCARDS';
export const MADE_FOR_YOU_SET_ACTIVE_TAB = 'MADE_FOR_YOU_SET_ACTIVE_TAB';
export const MADE_FOR_YOU_PUSH_ACTIVE_TAB = 'MADE_FOR_YOU_PUSH_ACTIVE_TAB';
export const MADE_FOR_YOU_SET_TAB_LIST = 'MADE_FOR_YOU_SET_TAB_LIST';
export const MADE_FOR_YOU_SET_IS_WIDGET = 'MADE_FOR_YOU_SET_IS_WIDGET';
export const MADE_FOR_YOU_SET_CURRENT_PAGE = 'MADE_FOR_YOU_SET_CURRENT_PAGE';
export const MADE_FOR_YOU_INCREASE_CURRENT_PAGE = 'MADE_FOR_YOU_INCREASE_CURRENT_PAGE';
export const MADE_FOR_YOU_DECREASE_CURRENT_PAGE = 'MADE_FOR_YOU_DECREASE_CURRENT_PAGE';
export const MADE_FOR_YOU_INIT = 'MADE_FOR_YOU_INIT';
export const MADE_FOR_YOU_REMOVE_BET_CARD = 'MADE_FOR_YOU_REMOVE_BET_CARD';
